
// menu - wyjeżdza poniżej wysokosci obrazka
"use strict";

(function() {
    var headerToModify = $(".header");
    var headerToModifyH = $(".header").height();
    var offsetToReach = headerToModifyH + 40;
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= offsetToReach) {
            headerToModify.addClass("fixed");
        } else if (scroll < offsetToReach) {
            headerToModify.removeClass("fixed");
        }
    });
})();